export default "__VITE_ASSET__BPuV1mk9__"